import accessories from "./assets/accessories.jpg";
import airplane from "./assets/airplane.jpg";
import chair from "./assets/chair.jpg";
import chicagoSign from "./assets/chicago-sign.jpg";
import city from "./assets/city.jpg";
import crab from "./assets/crab.jpg";
import curlingIron from "./assets/curling-iron.jpg";
import dubai from "./assets/dubai.jpg";
import eyebrows from "./assets/eyebrows.jpg";
import eyelash from "./assets/eyelash.jpg";
import footMassage from "./assets/foot-massage.jpg";
import hairAndComb from "./assets/hair-and-comb.jpg";
import hair from "./assets/hair.jpg";
import hair2 from "./assets/hair2.jpg";
import hair3 from "./assets/hair3.jpg";
import hair4 from "./assets/hair4.jpg";
import haircut from "./assets/haircut.jpg";
import handsInBowl from "./assets/hands-in-bowl.jpg";
import hollywoodSign from "./assets/hollywood-sign.jpg";
import island from "./assets/island.jpg";
import lasVegasSign from "./assets/las-vegas-sign.jpg";
import libertyBell from "./assets/liberty-bell.jpg";
import makeup from "./assets/makeup.jpg";
import massage2 from "./assets/massage-2.jpg";
import massageTable from "./assets/massage-table.jpg";
import massage from "./assets/massage.jpg";
import shampooing from "./assets/shampooing.jpg";
import shavingBowl from "./assets/shaving-bowl.jpg";
import statueOfLiberty from "./assets/statue-of-liberty.jpg";
import utensils from "./assets/utensils.jpg";
export const COMPANY_NAME = "Ocean Flowz International, LLC";

export const PAGES = ["Title", "Table of Contents", "Introduction", "Criteria & Admissions", "Positions Available", "Members Description", "Donations", "Coming Features"];

export const POSITIONS = ["Sales Representative", "Master Stylist/Master Barbers", "Stylist/Barbers", "Manicurists/Pedicurists", "Aesthetician (Facial & Make-up Artist)", "Weave/Extension Specialist", "Braid/Dread Specialist", "Masseuse/Masseurs"];

export const IMAGES = [accessories, airplane, chair, chicagoSign, crab, city, curlingIron, dubai, eyebrows, eyelash, footMassage, hairAndComb, hair, hair2, hair3, hair4, haircut, handsInBowl, hollywoodSign, island, lasVegasSign, libertyBell, makeup, massage, massage2, massageTable, shampooing, shavingBowl, statueOfLiberty, utensils];
